export class Locale {
  cpCode;
  cpLocaleCode;
  languageCode;
  description;

  constructor(obj?: Locale) {
    for (const prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        this[prop] = obj[prop];
      }
    }
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/captive-portal/locales/locale.model.ts